import isEmpty from 'lodash/isEmpty';

export default {
  data() {
    return {
      search: ''
    };
  },
  computed: {
    computedSearch: {
      set(newSearch) {
        this.search = newSearch;
      },
      get() {
        return this.search;
      }
    }
  },
  methods: {
    updateSearch(event) {
      this.search = isEmpty(event) ? null : event;
    }
  }
};
